import type { CustomerWorkbenchFormPayload } from "../types";

/** 客户星级标签仅在组织单元节点类型为二级学院时展示与必填。 */
export const CUSTOMER_STAR_COLLEGE_UNIT_TYPE = "二级学院";

/** 客户星级标签固定枚举与说明文案。 */
export const CUSTOMER_STAR_OPTION_DESCRIPTIONS: Record<string, string> = {
  A1级: "合作次数2次以上（无论出行人数），出行50人以上（无论合作次数），重本，985,211等知名学校",
  A2级: "未合作的重点学校或重本，985,211等知名学校",
  B1级: "合作1次，出行人数50人以下",
  B2级: "未合作50人以下",
  C级: "未合作，不出行",
};

export const CUSTOMER_STAR_OPTIONS = Object.keys(CUSTOMER_STAR_OPTION_DESCRIPTIONS);

/** 判断是否应展示客户星级标签。 */
export function shouldShowCustomerStar(unitType?: string | null) {
  return unitType === CUSTOMER_STAR_COLLEGE_UNIT_TYPE;
}

/** 校验客户表单在二级学院场景下已选择星级。 */
export function validateCustomerStarForSave(payload: CustomerWorkbenchFormPayload, unitType?: string | null) {
  if (!shouldShowCustomerStar(unitType)) {
    return null;
  }
  if (!payload.customerStar?.trim()) {
    return "二级学院客户必须选择星级标签";
  }
  if (!CUSTOMER_STAR_OPTIONS.includes(payload.customerStar)) {
    return "星级标签不在可选范围内";
  }
  return null;
}
